var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-tag-fire"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v(_vm._s(_vm.g_getTools02TagCategoryName(_vm.toolId))+" 発火")])])],1),_c('TagFireEditor',{attrs:{"toolId":_vm.toolId,"tagId":_vm.tagId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }